import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type TableHeaderProps = ComponentProps<'thead'>;

const TableHeader = ({ className, ...props }: TableHeaderProps) => {
  return (
    <thead
      data-slot="table-header"
      className={cn('[&_tr]:border-b [&_tr:hover]:bg-transparent', className)}
      {...props}
    />
  );
};

export default TableHeader;
